/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBarberAppointmentsIdCompleteMutationResponse, PostApiBarberAppointmentsIdCompletePathParams, PostApiBarberAppointmentsIdComplete400, PostApiBarberAppointmentsIdComplete401, PostApiBarberAppointmentsIdComplete403, PostApiBarberAppointmentsIdComplete404, PostApiBarberAppointmentsIdComplete500 } from "../entities/PostApiBarberAppointmentsIdComplete";

function getPostApiBarberAppointmentsIdCompleteUrl(id: PostApiBarberAppointmentsIdCompletePathParams["id"]) {
  const res = { method: 'POST', url: `/api/barber/appointments/${id}/complete` as const }
  return res
}

/**
 * @description Мастер завершает стрижку
 * @summary Завершить стрижку
 * {@link /api/barber/appointments/:id/complete}
 */
export async function postApiBarberAppointmentsIdComplete(id: PostApiBarberAppointmentsIdCompletePathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PostApiBarberAppointmentsIdCompleteMutationResponse, ResponseErrorConfig<PostApiBarberAppointmentsIdComplete400 | PostApiBarberAppointmentsIdComplete401 | PostApiBarberAppointmentsIdComplete403 | PostApiBarberAppointmentsIdComplete404 | PostApiBarberAppointmentsIdComplete500>, unknown>({ method : "POST", url : getPostApiBarberAppointmentsIdCompleteUrl(id).url.toString(), ... requestConfig })
  return res.data
}